import type { ReactNode } from 'react';
import { EmptyState, ErrorNote, Skeleton } from './ui/index.js';

export function Panel(props: {
  loading: boolean;
  error: string | null;
  empty: boolean;
  emptyLabel: string;
  emptyHint?: string | undefined;
  children: ReactNode;
}) {
  if (props.loading) return <Skeleton />;
  if (props.error) return <ErrorNote message={props.error} />;
  if (props.empty) return <EmptyState title={props.emptyLabel} hint={props.emptyHint} />;
  return <>{props.children}</>;
}
